<template>
    <div id="login-news-new">
        <transition name="fade" mode="out-in">
            <login-news-list key="news-list-view"
                             v-if="currentItem === null"
                             :news-list="news"
                             :current-page.sync="page"
                             @select="showElement"
            ></login-news-list>
            <login-news-detail key="news-detail-view"
                               v-else
                               :_current-item="currentItem"
                               :news-list="news"
                               @reset="currentItem = null"
            ></login-news-detail>
        </transition>
        <div v-show="showLoader" class="loader-mask">
            <div class="loader"></div>
        </div>
    </div>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
    #login-news-new {
        width: 100%;
        max-width: 1000px;
        padding: 0;
        color: white;

        .loader-mask {
            &, &::before {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
            }

            &::before {
                content: '';
                opacity: 0.4;
                background: gray;
            }

            .loader::after {
                width: 60px;
                height: 60px;
                border-width: 8px;
                animation: spin 1s linear infinite;
            }
        }
    }
</style>

<script>
    import LoginNewsList from './LoginNewsList.vue';
    import LoginNewsDetail from './LoginNewsDetail.vue';

    export default {
        name: 'LoginNews',
        components: {
            LoginNewsList,
            LoginNewsDetail,
        },
        data() {
            return {
                news: [],
                currentItem: null,
                page: 1,
                showLoader: false,
            };
        },
        created() {
            this.LOCAL_BASE = '';
            this.PROD_BASE = 'https://dr100.pl';
            this.PATH = '/secure/api/v1/login_news/';
            this.IS_DEMO = window.isDemo;

            this.getNews();
        },
        methods: {
            showElement(item) {
                this.currentItem = item;
            },
            getUrl() {
                const Base = this.IS_DEMO ? this.PROD_BASE : this.LOCAL_BASE;
                return `${Base}${this.PATH}`;
            },
            getNews() {
                const url = this.getUrl();
                this.showLoader = true;
                return $.ajax({
                    method: 'GET',
                    url,
                    crossDomain: this.IS_DEMO,
                    data: {paginate: false},
                }).then((news) => {
                    // first try the 'results' field in case prod hasn't been updated yet
                    this.news = news.results || news;
                }, (jqXHR) => {
                    Raven.captureMessage(
                        'Request for login news failed.',
                        { extra: { url, jqXHR } },
                    );
                }).always(() => {
                    this.showLoader = false;
                });
            },
        },
    };
</script>



// WEBPACK FOOTER //
// LoginNews.vue?935d093a